import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  FormGroup,
  ReactiveFormsModule,
  FormArray,
  FormBuilder,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { AddstaffassignmentService } from '../../../../../inputfileds/form_services/Assignmentsservices/staffassignments/addstaffqesassignments/addstaffassignment.service';
import { QuestionControlService } from '../../../../../inputfileds/form_services/question-control.service';
import { Inputfiledsbase } from '../../../../../inputfileds/models/inputfiledsbase';
import { DynamicFormQuestionComponent } from '../../../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { SubmittedSuccessComponentComponent } from '../../../../../components/Assignments/submitted-success-component/submitted-success-component.component';
import { environment } from '../../../../../../environments/environment';
import { TranslateDirective } from '../../../../../components/Utilites/Directives/translate.directive';

@Component({
  selector: 'app-addliststaffassignment',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    DynamicFormQuestionComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    MatDatepickerModule,
    MatSlideToggleModule,
    MatNativeDateModule,
    SubmittedSuccessComponentComponent,
    TranslateDirective
  ],
  providers: [QuestionControlService],
  templateUrl: './addstaffassignmentlist.component.html',
  styleUrls: ['./addstaffassignmentlist.component.scss'],
})
export class AddliststaffassignmentComponent {
  @Input() assignment: any = null;
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  questions: Inputfiledsbase<string>[] = [];
  form!: FormGroup;
  private questionCounter = 1;
  isFirstQuestionStatic = true;

  submitted = false; // track submission state
  isSubmitted = false;
  showDetails = false;
  isDisabled = false;
  Created = 'created';
  imageUrl =
    environment.ASSET_URL +
    environment.ASSET_CONTAINER +
    '/' +
    'ERP/assets/common/Success.gif';

  constructor(
    private addStaffQuesAssignmentsService: AddstaffassignmentService,
    private qcs: QuestionControlService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    // 1. Initialize the form with all non-asynchronous controls first
    this.form = this.fb.group({
      deadline: [null],
      lateSubmission: [false],
      // block 2 questions as FormArray
      customQuestions: this.fb.array([]),
    });

    // 2. Fetch the questions asynchronously
    this.addStaffQuesAssignmentsService
      .getStaffAssignmentsQuestion()
      .subscribe((q) => {
        // 3. Create a form group for the dynamic questions
        const dynamicQuestionFormGroup = this.qcs.toFormGroup(q);

        // 4. Add the controls from the dynamic form group to the main form
        Object.keys(dynamicQuestionFormGroup.controls).forEach((key) => {
          this.form.addControl(key, dynamicQuestionFormGroup.get(key));
        });

        // 5. Populate the questions array for the template
        this.questions = q;
      });
    this.addQuestion();
  }

  get customQuestions(): FormArray {
    return this.form.get('customQuestions') as FormArray;
  }
  onCancel() {
    this.close.emit();
  }

  onSave() {
    if (this.form.valid) {
      this.assignment = this.form.value;
      this.submitted = true;
      this.isSubmitted = true;
      this.showDetails = false;
      this.isDisabled = false;
      console.log(this.form.valid, 'this.form.valid');
    }
  }

  addQuestion() {
    const questionGroup = this.fb.group({
      text: [''],
      marks: [''],
      attachment: [null],
    });
    this.customQuestions.push(questionGroup);
  }

  // 🔹 Delete a question
  deleteQuestion(index: number) {
    this.customQuestions.removeAt(index);
  }
  onFileSelected(event: Event, index: number) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.customQuestions.at(index).get('attachment')?.setValue(file);
    }
  }
  goBack() {
    this.submitted = false;
    this.form.reset();
    this.customQuestions.clear();
    this.addQuestion();
  }

  viewSubmissionDetails() {
    this.submitted = true;
    this.isSubmitted = true;
    this.showDetails = true;
    this.isDisabled = true;

    // 🟢 Repopulate the form with the saved data from the 'assignment' object
    if (this.assignment) {
      this.form.patchValue({
        deadline: this.assignment.deadline,
        lateSubmission: this.assignment.lateSubmission,
      });

      // Clear the FormArray first
      this.customQuestions.clear();

      // Repopulate the custom questions FormArray
      if (this.assignment.customQuestions) {
        this.assignment.customQuestions.forEach((q: any) => {
          const questionGroup = this.fb.group({
            text: [q.text],
            marks: [q.marks],
            attachment: [q.attachment],
          });
          this.customQuestions.push(questionGroup);
        });
      }
    }
  }
}
